import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Suspense, lazy, useEffect } from 'react';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import AnimatedBackground from './components/AnimatedBackground';
import HeroSkeletonLoader from './components/Main-Page/HeroSkeletonLoader';
import SkeletonLoader from './components/SkeletonLoader';
import NotFound from './components/NotFound';
import useRouteHistory from './hooks/useRouteHistory';

// Lazy load heavy components
const Home = lazy(() => import('./pages/Home'));
const ApnaEduHub = lazy(() => import('./pages/ApnaEduHub'));
const HotelManagement = lazy(() => import('./pages/HotelManagement'));
const Ecommerce = lazy(() => import('./pages/Ecommerce'));

const HomePage = () => {
  useRouteHistory();
  return (
    <Suspense fallback={<HeroSkeletonLoader />}>
      <Home />
    </Suspense>
  );
};

const ApnaEduHubPage = () => {
  useRouteHistory();
  return (
    <Suspense fallback={<SkeletonLoader />}>
      <ApnaEduHub />
    </Suspense>
  );
};

const HotelManagementPage = () => {
  useRouteHistory();
  return (
    <Suspense fallback={<SkeletonLoader />}>
      <HotelManagement />
    </Suspense>
  );
};

const EcommercePage = () => {
  useRouteHistory();
  return (
    <Suspense fallback={<SkeletonLoader />}>
      <Ecommerce />
    </Suspense>
  );
};

const AppContent = () => {
  const { theme } = useTheme();

  useEffect(() => {
    // Update body class based on theme
    if (theme === 'light') {
      document.body.className = 'light-theme';
      document.documentElement.style.background = 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 50%, #e5e7eb 100%)';
    } else {
      document.body.className = 'dark-theme';
      document.documentElement.style.background = 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)';
    }
  }, [theme]);

  return (
    <div className={`min-h-screen overflow-x-hidden ${
      theme === 'light' ? 'bg-gray-50' : 'bg-gray-900'
    }`}>
      <AnimatedBackground />
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/apnaeduhub" element={<ApnaEduHubPage />} />
          <Route path="/school-erp-software" element={<ApnaEduHubPage />} />
          <Route path="/best-school-management-system" element={<ApnaEduHubPage />} />
          <Route path="/college-management-system" element={<ApnaEduHubPage />} />
          <Route path="/hotel-management" element={<HotelManagementPage />} />
          <Route path="/hotel-management-software" element={<HotelManagementPage />} />
          <Route path="/restaurant-pos-system" element={<HotelManagementPage />} />
          <Route path="/ecommerce" element={<EcommercePage />} />
          <Route path="/ecommerce-platform" element={<EcommercePage />} />
          <Route path="/online-store-builder" element={<EcommercePage />} />
          <Route path="/demo" element={<ApnaEduHubPage />} />
          <Route path="/free-demo" element={<ApnaEduHubPage />} />
          <Route path="/pricing" element={<HomePage />} />
          <Route path="/contact" element={<HomePage />} />
          <Route path="/about" element={<HomePage />} />
          <Route path="/products" element={<HomePage />} />
          {/* Catch all undefined routes and redirect to NotFound */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;